import { useNavigate } from 'react-router'
import { Button } from '@/shared/components/ui/button'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg)]">
      <div className="text-center max-w-md px-6">
        <p className="mb-2 text-[11px] uppercase tracking-[0.14em] text-[var(--ink-3)]">
          404
        </p>
        <h1 className="mb-3 text-[32px] text-[var(--ink)] font-display">
          Page not found
        </h1>
        <p className="mb-8 text-[13px] text-[var(--ink-3)]">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="cursor-pointer rounded-[4px] border-[0.5px] border-[var(--rule)] bg-[var(--bg-subtle)] px-4 py-2 text-[11px] uppercase tracking-[0.1em] text-[var(--ink-2)] transition-all duration-150 hover:bg-[var(--bg-subtle)]"
          >
            Go back
          </Button>
          <Button
            variant="default"
            onClick={() => navigate('/', { replace: true })}
            className="cursor-pointer rounded-[4px] bg-[var(--green)] px-4 py-2 text-[11px] uppercase tracking-[0.1em] text-[var(--bg)] transition-all duration-150 hover:bg-[var(--green-hover)]"
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  )
}
